// src/ui-runtime/runtime-ui-signature.ts
var RUNTIME_UI_SIGNATURE_PATTERN = /^uic_[a-z0-9]{1,32}$/;
var RUNTIME_UI_FRAME_PREFIX = "fh:";
var RUNTIME_UI_SIGNATURE_REFERENCE_PATTERN = new RegExp(
  `^(?:${RUNTIME_UI_FRAME_PREFIX})?uic_[a-z0-9]{1,32}$`
);

export { RUNTIME_UI_FRAME_PREFIX, RUNTIME_UI_SIGNATURE_PATTERN, RUNTIME_UI_SIGNATURE_REFERENCE_PATTERN };
//# sourceMappingURL=chunk-DHOJC3F4.js.map
//# sourceMappingURL=chunk-DHOJC3F4.js.map